import React, { useMemo } from 'react';
import { Box } from '@mui/material';
// import AssignmentIcon from '@mui/icons-material/Assignment';
import { stepsComplete, stepsProcurationAe, stepsProcurationSap } from '../config/StepperConfig';
import BrandStepper, { StepConfig } from './shared/BrandStepper';

interface StepperProcurationProps {
    currentStep: number;
    type: 'complete' | 'procuration-ae' | 'procuration-sap'
}

const StepperProcuration: React.FC<StepperProcurationProps> = ({ currentStep, type }) => {
    const steps: StepConfig[] = useMemo(() => {
        if (type === 'complete') {
            return stepsComplete
        }
        if (type === 'procuration-sap') {
            return stepsProcurationSap;
        }
        return stepsProcurationAe
    }, [type])

    return (
        <Box className="w-full py-6 px-4 lg:px-8">
            <BrandStepper
                steps={steps}
                activeStep={currentStep}
                alternativeLabel={true}
            />
        </Box>
    );
};

export default StepperProcuration;
